// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.5 3H7V6.5H9V5H10.5V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.5 3H12.5V5H15.5V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 3H17.5V5H19V6.5H21V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M5 19V7.5H3V21H16.5V19H5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9 11.5V8.5H7V11.5H9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 11.5V8.5H19V11.5H21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9 15V13.5H7V17H10.5V15H9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 17V13.5H19V15H17.5V17H21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.5 15H12.5V17H15.5V15Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17 7H11V13H17V7Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-flip-to-back-filled')
export default class FlipToBackFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flip-to-back-filled',
    }
  }
}
